"use client";

import { createAuthClient } from "better-auth/react";

/**
 * Browser side of Better Auth, used only to log in through `/api/auth/sign-in/email`, so the
 * library's per-IP rate limit and the per-email limit apply. Everything else goes through
 * Server Actions.
 */
const client = createAuthClient();

export type SignInOutcome = { ok: true } | { ok: false; reason: "invalid" | "rate_limited" | "network" };

export async function signInWithPassword(email: string, password: string): Promise<SignInOutcome> {
  try {
    const { error } = await client.signIn.email({ email, password });
    if (!error) return { ok: true };
    // One answer for unknown email, wrong password or deactivated account: nothing to learn from it.
    return { ok: false, reason: error.status === 429 ? "rate_limited" : "invalid" };
  } catch {
    return { ok: false, reason: "network" };
  }
}
